// render

import { createColumnHelper } from "@tanstack/react-table";
import { useSelector } from "react-redux";
import DashboardTable from "./DashboardTable";
import { Link } from "react-router-dom";

const columnHelper = createColumnHelper();
function OrdersTable() {
  const { dashboardData, dashboardLoading, dashboardError } = useSelector(
    (state) => state.dashboard
  );
  const { orderStatusData } = useSelector(
    (state) => state.orders
  );

  const orders = dashboardData?.data?.orders;
  const ordersData = orders?.byStatus
    ? Object.entries(orders.byStatus).map(([status, count]) => ({
        status,
        count,
      }))
    : [];
  const getEnumVal = (statusName) => {
    const statusObj = orderStatusData?.find(
      (s) => s.name.toLowerCase() === statusName.toLowerCase()
    );
    return statusObj?.enumVal || "unknown";
  };

  const ordersColumns = [
    columnHelper.accessor("status", {
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          STATUS
        </p>
      ),
      cell: (info) => {
        const enumVal = getEnumVal(info.getValue());
        return (
          <Link
            to={`/orders/${enumVal}`}
            className="text-sm font-bold text-navy-700 dark:text-white"
          >
            {info.getValue()}
          </Link>
        );
      },
    }),
    columnHelper.accessor("count", {
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">COUNT</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
  ];

  return (
    <DashboardTable
      title="Orders Table"
      columns={ordersColumns}
      data={ordersData}
      loading={dashboardLoading}
      error={dashboardError}
    />
  );
}

export default OrdersTable;
